var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.394 25.081L48 19.341V8C47.9999 7.73481 47.8946 7.48049 47.707 7.293L42.707 2.293C42.5195 2.10545 42.2652 2.00006 42 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V59C2 59.7957 2.31607 60.5587 2.87868 61.1213C3.44129 61.6839 4.20435 62 5 62H45C45.7957 62 46.5587 61.6839 47.1213 61.1213C47.6839 60.5587 48 59.7957 48 59V56.514L53.206 52.8C55.9243 50.8546 58.1398 48.2894 59.6691 45.317C61.1984 42.3447 61.9975 39.0507 62 35.708V26C62 25.8043 61.9426 25.613 61.8348 25.4496C61.7271 25.2863 61.5738 25.1581 61.394 25.081ZM46 8.414V9H41V4H41.586L46 8.414ZM45 60H5C4.73478 60 4.48043 59.8946 4.29289 59.7071C4.10536 59.5196 4 59.2652 4 59V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H39V10C39 10.2652 39.1054 10.5196 39.2929 10.7071C39.4804 10.8946 39.7348 11 40 11H46V19.341L32.606 25.081C32.4262 25.1581 32.2729 25.2863 32.1652 25.4496C32.0574 25.613 32 25.8043 32 26V35.708C32.0025 39.0507 32.8016 42.3447 34.3309 45.317C35.8602 48.2894 38.0757 50.8546 40.794 52.8L46 56.514V59C46 59.2652 45.8946 59.5196 45.7071 59.7071C45.5196 59.8946 45.2652 60 45 60ZM60 35.708C59.9968 38.7317 59.2735 41.7111 57.89 44.3997C56.5065 47.0883 54.5025 49.4088 52.044 51.169L47 54.771L41.956 51.171C39.4972 49.4106 37.4931 47.0898 36.1096 44.4008C34.726 41.7119 34.0029 38.732 34 35.708V26.659L47 21.088L60 26.659V35.708Z",
    fill: "#157B7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 23.923L36.629 28.071C36.4433 28.1452 36.2841 28.2734 36.1719 28.439C36.0598 28.6046 35.9999 28.8 36 29V35.31C35.9999 37.8595 36.5733 40.3764 37.6777 42.6743C38.7821 44.9722 40.3892 46.9923 42.38 48.585L47 52L51.62 48.585C53.6108 46.9923 55.2179 44.9722 56.3223 42.6743C57.4267 40.3764 58.0001 37.8595 58 35.31V29C58.0001 28.8 57.9402 28.6046 57.8281 28.439C57.7159 28.2734 57.5567 28.1452 57.371 28.071L47 23.923ZM56 29.677V35.31C56.0055 37.5604 55.5018 39.7828 54.5269 41.8111C53.5519 43.8393 52.1308 45.6207 50.37 47.022L47 49.72L43.63 47.02C41.8694 45.6189 40.4485 43.8378 39.4736 41.8099C38.4986 39.7821 37.9949 37.56 38 35.31V29.677L47 26.077L56 29.677Z",
    fill: "#157B7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H18V16H6V14Z",
    fill: "#157B7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H40V16H20V14Z",
    fill: "#157B7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H24V12H6V10Z",
    fill: "#157B7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H37V12H26V10Z",
    fill: "#157B7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H18V24H6V22Z",
    fill: "#157B7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H31V24H20V22Z",
    fill: "#157B7D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H24V20H6V18Z",
    fill: "#157B7D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H40V20H26V18Z",
    fill: "#157B7D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H16V8H6V6Z",
    fill: "#157B7D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H37V8H18V6Z",
    fill: "#157B7D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29 44H7C6.73478 44 6.48043 44.1054 6.29289 44.2929C6.10536 44.4804 6 44.7348 6 45V57C6 57.2652 6.10536 57.5196 6.29289 57.7071C6.48043 57.8946 6.73478 58 7 58H29C29.2652 58 29.5196 57.8946 29.7071 57.7071C29.8946 57.5196 30 57.2652 30 57V45C30 44.7348 29.8946 44.4804 29.7071 44.2929C29.5196 44.1054 29.2652 44 29 44ZM28 56H8V46H28V56Z",
    fill: "#157B7D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26H7C6.73478 26 6.48043 26.1054 6.29289 26.2929C6.10536 26.4804 6 26.7348 6 27V41C6 41.2652 6.10536 41.5196 6.29289 41.7071C6.48043 41.8946 6.73478 42 7 42H29C29.2652 42 29.5196 41.8946 29.7071 41.7071C29.8946 41.5196 30 41.2652 30 41V27C30 26.7348 29.8946 26.4804 29.7071 26.2929C29.5196 26.1054 29.2652 26 29 26ZM28 40H8V28H28V40Z",
    fill: "#157B7D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.707 37.293L41.293 38.707L44.293 41.707C44.4805 41.8946 44.7348 41.9999 45 42H45.033C45.1699 41.9955 45.3045 41.963 45.4284 41.9043C45.5523 41.8456 45.6627 41.7621 45.753 41.659L52.753 33.659L51.247 32.343L44.947 39.543L42.707 37.293Z",
    fill: "#157B7D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H26V32H24V30Z",
    fill: "#157B7D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48H26V50H24V48Z",
    fill: "#157B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.5fee5d3ae75efb0872253215bac6ff1d.svg";
export { ForwardRef as ReactComponent };